export default __webpack_public_path__ + "static/neue-haas-grotesk-display-65-medium-6b08a8ed90187ba46180a2d91cf63b7d.woff";